import StatusCodes from '../model/StatusCodes';

export default { responseError: responseError };

function responseError (response) {
  return {
    status: response ?
      response.status ?
        parseInt(response.status._text, 10) :
        response.code || StatusCodes.UNKNOWN_ERROR :
      StatusCodes.UNKNOWN_ERROR,
    data: response.data || null,
    message: response ? (response.message ? response.message._cdata : response.message) : '',
  };
}



// WEBPACK FOOTER //
// ./src/remoting/ResponseError.js